
import TElogo from "../../../../assets/images/dod_logo.png";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { useDispatch } from "react-redux";
import deskImg from "../../../../assets/images/DodUserLoginpannel/Desk iMAGE png.png"; 
import { userForgotPasswordApi, UserVerifyEmailApi } from "../../../../services/apis/AuthService";
import BtnLoader from "../../../components/Loader/btnLoader";
import { Toaster } from "../../../components/Toaster/Toster";
import { FaArrowLeft } from "react-icons/fa";

const UserForgotPassword=()=>{
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [email, setEmail] = useState("");
    let errorsObj = { email: "", password: "" };
    const [errors, setErrors] = useState(errorsObj);
    const [password, setPassword] = useState("");
    const [submitted, setSubmitted] = useState(false);
    const [btnLoading, setBtnLoading] = useState(false);

    const validateFields = () => {
        const errorObj = { email: "", password: "" };
        let isError = false;
        if (!email) {
          errorObj.email = "Email is required";
          isError = true;
        }
     
        setErrors(errorObj);
        return isError;
      };
    
      // Reset the specific error when the user starts typing
      const handleInputChange = (e, field) => {
        if (field === "email") {
          setEmail(e.target.value);
          if (submitted && errors.email) {
            setErrors((prevErrors) => ({ ...prevErrors, email: "" }));
          }
        } else if (field === "password") {
          setPassword(e.target.value);
          if (submitted && errors.password) {
            setErrors((prevErrors) => ({ ...prevErrors, password: "" }));
          }
        }
      };

      const handleUserForgotPassword = async (e) => {
        e.preventDefault();
        const isFormValid = validateFields();
        if (isFormValid) {
          return; 
        }
        const formData = {
          email: email,
        };      
        setBtnLoading(true);
        try {
          const res = await userForgotPasswordApi(formData);
           //console.log(res)
           const resData= res?.data;
           const stateData={
            email:email,
            // otp:resData?.otp
          }
          if (resData.success) {
            navigate("/user-otp-verification", {state:stateData});
            Toaster.success(res?.data?.message);
          } else {
            console.log("Login not successfully done");
          }

          console.log("resss",res)
        } catch (err) {
          console.log(err);
          Toaster.error(err.response?.data?.message);
        }finally{
          setBtnLoading(false);
        }
      };
    

    return(<>
      <ToastContainer/>
     <div className="container-xl">
         <div className="user-login-video-section">
              {/* <video className="user-login-df-video" autoPlay muted loop controls={false}>
               <source src={dfVideo} type="video/mp4" />
              </video> */}
              <div className="overlay-section"></div>
         </div>

         <div className="main-content-box row">
            <div className="col-md-6 d-flex flex-column align-items-center align-items-lg-start user-login-left-section">
              <img className="user-login-logo" src={TElogo} alt="logo"/>

              <img className="user-login-deskimg d-none d-sm-block" src={deskImg} alt="logo2"/>

              {/* <h4 className="login-welcome-text text-white">Welcome back User !</h4>
              <h1 className="user-login-text">Sign in</h1>

              <hr className="d-none d-sm-block login-bottom-line"/> */}
            </div>

            <div className="col-md-6 user-login-right-section mt-4 mt-sm-0">
               <div className="user-login-section">
                <form  onSubmit={handleUserForgotPassword}>
                  <div className="mb-3">
                  <h1 className="user-login-text mb-0">Forgot Password</h1>
                  <h4 className="user-login-join-text text-white">Enter your registered email address to receive a one-time password (OTP) to reset your password.</h4>
                </div>
                      <div className="mb-3">
                        <label className="mb-1 text-white">
                          <strong>Email</strong>
                        </label>
                        <input
                          type="email"
                          className="form-control user-login-input-box"
                          value={email}
                          // onChange={(e) => setEmail(e.target.value)}
                          onChange={(e) => handleInputChange(e, "email")}
                          placeholder="Type Your Email Address"
                        />
                        {errors.email && (
                          <div className="text-danger fs-12">
                            {errors.email}
                          </div>
                        )}
                      </div>
                
                      <div className="text-center">
                        <button type="submit" className="btn text-white btn-block user-login-btn">
                          {btnLoading && <BtnLoader />}
                           Submit
                          {/* <img className="user-login-connect-img" src={connectImg} alt="connect-img"/> */}
                        </button>
                      </div>
                    </form>
                    <button
                    type="button"
                    className="btn text-white mt-3 px-3"
                    onClick={() => navigate("/user/login")}>
                    <FaArrowLeft /> Go back
                  </button>
               </div>
              
            </div>
         </div>
     
     </div>
    </>)
};

export default UserForgotPassword;